import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TBillingState } from './types';

export function useBillingQuoteBilling(quoteId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TBillingState | null>(
    quoteId ? `commenda-billing/quotes/${quoteId}/billing` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { billing: data ?? null, error, isLoading, mutate };
}
